import React from 'react';
import Icon from '../../../components/AppIcon';

const AIRecommendationBanner = ({ recommendations, onRouteClick, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-gradient-to-r from-primary/10 to-primary/5 rounded-xl p-4 mb-6 border border-primary/20">
        <div className="flex items-center gap-3">
          <div className="animate-spin">
            <Icon name="Sparkles" size={24} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">AI Önerileri Hazırlanıyor...</p>
            <p className="text-xs text-muted-foreground mt-1">Konumunuza en uygun rotalar analiz ediliyor</p>
          </div>
        </div>
      </div>
    );
  }

  if (!recommendations || !recommendations?.recommendations || recommendations?.recommendations?.length === 0) {
    return null;
  }

  const topRecommendation = recommendations?.recommendations?.[0];
  const otherRecommendations = recommendations?.recommendations?.slice(1, 3);

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'bg-success/10 text-success border-success/20';
      case 'medium':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'low':
        return 'bg-muted/50 text-muted-foreground border-border';
      default:
        return 'bg-primary/10 text-primary border-primary/20';
    }
  };

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'high':
        return 'TrendingUp';
      case 'medium':
        return 'ArrowRight';
      case 'low':
        return 'ArrowDown';
      default:
        return 'Info';
    }
  };

  return (
    <div className="bg-gradient-to-r from-primary/10 to-primary/5 rounded-xl p-4 md:p-5 mb-6 border border-primary/20 shadow-lg">
      {/* Header */}
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Sparkles" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg font-bold text-foreground">AI Önerileri</h3>
        <span className="ml-auto text-xs px-2 py-1 bg-primary/20 text-primary rounded-full font-medium">
          Gemini AI
        </span>
      </div>

      {/* Summary */}
      {recommendations?.summary && (
        <p className="text-sm text-muted-foreground mb-4">
          {recommendations?.summary}
        </p>
      )}

      {/* Top Recommendation */}
      {topRecommendation && (
        <div 
          className={`p-3 md:p-4 rounded-lg border mb-3 cursor-pointer hover:shadow-md transition-all ${getPriorityColor(topRecommendation?.priority)}`}
          onClick={() => onRouteClick?.(topRecommendation?.routeId)}
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-1">
              <Icon name={getPriorityIcon(topRecommendation?.priority)} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-bold">En İyi Öneri</span>
                <span className="text-xs px-2 py-0.5 bg-white/50 rounded-full font-semibold">
                  {topRecommendation?.score}/100
                </span>
              </div>
              <p className="text-xs md:text-sm leading-relaxed">
                {topRecommendation?.reason}
              </p>
            </div>
            <Icon name="ChevronRight" size={18} className="flex-shrink-0 mt-1" />
          </div>
        </div>
      )}

      {/* Other Recommendations */}
      {otherRecommendations?.length > 0 && (
        <div className="space-y-2">
          {otherRecommendations?.map((rec, index) => (
            <div
              key={rec?.routeId || index}
              className={`p-2 md:p-3 rounded-lg border cursor-pointer hover:shadow-sm transition-all ${getPriorityColor(rec?.priority)}`}
              onClick={() => onRouteClick?.(rec?.routeId)}
            >
              <div className="flex items-center gap-2">
                <Icon name={getPriorityIcon(rec?.priority)} size={16} />
                <span className="text-xs px-1.5 py-0.5 bg-white/50 rounded font-semibold">
                  {rec?.score}/100
                </span>
                <p className="text-xs flex-1 truncate">{rec?.reason}</p>
                <Icon name="ChevronRight" size={14} className="flex-shrink-0" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AIRecommendationBanner;